import LoginPage from "../components/LoginPage/loginPage";

const Homepage = () =>{
    return <main>
        <LoginPage/>
    </main>
}

export default Homepage;